<template>
  <div
    class="
      flex
      items-center
      h-16
      py-4
      flex-shrink-0
      justify-center
      relative
      group
      shadow
    "
    :class="{
      'bg-secondary-darker': dark,
      'bg-grey-50': origin === 'groovepages'
    }"
  >
    <div class="p-2 rounded-lg" :class="{'shadow-lg': origin === 'groovepages'}">
      <img :src="brandData.brandLogo" class="h-8 w-8" />
    </div>
    <div
      class="
        bg-white
        rounded-lg
        shadow-md
        top-full
        w-100
        border-solid border border-grey-200
        shadow
        overflow-y-auto
        top-0
        left-0
        absolute
        z-50
        hidden
        group-hover:block
        ml-2
      "
      style="max-height: 90vh; min-height: 24rem"
    >
      <div class="bg-white p-4">
        <div class="">
          <div class="relative">
            <div
              class="
                inline-flex
                shadow-sm
                rounded-md
                divide-x divide-indigo-600
              "
            >
              <div
                class="
                  relative
                  z-0
                  inline-flex
                  shadow-sm
                  rounded-md
                  divide-x divide-indigo-600
                "
              >
                <div class="relative inline-block text-left">
                  <div
                    class="
                      relative
                      inline-flex
                      items-center
                      bg-indigo-500
                      border border-transparent
                      rounded-l-md
                      shadow-sm
                      text-grey-700
                      cursor-pointer
                    "
                    @click="swithcApp()"
                  >
                    <p class="text-md font-semibold">
                      {{ selectedCategory.title }}
                    </p>
                    <!-- Heroicon name: solid/chevron-down -->
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="openViewSwitcher"
                    v-on-click-outside="outSideMainMenu()"
                    class="
                      origin-top-right
                      absolute
                      left-0
                      mt-2
                      w-56
                      rounded-lg
                      shadow-md
                      border border-grey-200
                      shadow
                      bg-white
                      ring-opacity-5
                      focus:outline-none
                    "
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabindex="-1"
                  >
                    <div class="py-1" role="none">
                      <a
                        v-for="(category, index) in appCategories"
                        :key="index"
                        @click="
                          (selectedCategory = category),
                            (openViewSwitcher = false)
                        "
                        href="#"
                        class="
                          text-grey-700
                          hover:bg-grey-100
                          block
                          px-4
                          py-2
                          text-sm
                        "
                        role="menuitem"
                        tabindex="-1"
                        id="menu-item-0"
                      >
                        {{ category.title }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <a
              v-for="(app, index) in hoveredCategoryApps(selectedCategory)"
              :key="index"
              :href="app.url"
              class="
                -m-3
                p-3
                flex
                rounded-lg
                hover:bg-grey-100
                transition
                ease-in-out
                duration-150
              "
              :target="app.target"
              @click="handleRedirect($event, app.url, app.target)"
            >
              <div
                class="
                  flex flex-col
                  items-center
                  justify-center
                  border border-grey-100
                  rounded
                  h-10
                  w-10
                  shadow
                "
                v-if="app.logo"
              >
                <img :src="app.logo" class="flex-shrink-0 h-6 w-6" />
              </div>
              <div class="flex flex-col" :class="{ 'ml-3': app.logo }">
                <p class="text-sm font-semibold text-grey-700">
                  {{ app.title }}
                </p>
                <p class="text-xs text-grey-600">
                  {{ app.description }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroovePagesLogo from '../assets/groovepages-logo-small.svg';
import AcademyMenu from './AcademyMenu';
import MultiLevelDropdown from './MultiLevelDropdown';
import SupportMenu from './SupportMenu';

export default {
  name: 'NavDropdown',
  components: {
    MultiLevelDropdown,
    AcademyMenu,
    SupportMenu,
    GroovePagesLogo
  },
  props: {
    logo: {},
    dark: {
      default: true,
    },
    origin: {}
  },
  data() {
    return {
      mainMenu: true,
      childCategory: [],
      openApplicationSwitcher: false,
      selectedCategory: {
        "title": "Apps",
        "description": "All Groove Apps",
        "icon": "https://assets.grooveapps.com/css/groovecm.svg",
        "type": "apps"
      },
      openViewSwitcher: false,
    };
  },
  computed: {
    brandData() {
      return this.$store.getters.brandData;
    },
    appCategories () {
      if (!this.brandData) return [];
      return this.brandData.appCategories;
    },
    apps() {
      if (!this.brandData) return [];
      return this.brandData.apps;
    }
  },
  methods: {
    swithcApp() {
      this.openViewSwitcher = !this.openViewSwitcher;
    },
    outSideMainMenu() {},
    hideAllDropdowns() {},
    hoveredCategoryApps(type) {
      let selectedApps = [];
      if (type != '' && this.apps) {
        selectedApps = this.apps.filter((e) => {
          return e.type.includes(type.type) && e.title != 'GrooveDesignerPro';
        });
      }
      return selectedApps;
    },

    onMouseOver(name) {},

    onMouseLeave(name) {},
  },
  watch: {
    hoveredCategory(newValue) {
      if (newValue && newValue != '') {
        this.hoveredApps = this.apps.filter((e) => {
          return e.type.includes(newValue);
        });
      } else {
        this.hoveredApps = [];
      }
    },
  },
};
</script>

